import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Container, Paper } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useAuth } from '../hooks/useAuth';

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f0f2f5',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 4,
          }}
        >
          <Typography variant="h4" fontWeight={700} color="primary" gutterBottom>
            VProxy
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            企业代理管理平台
          </Typography>

          <Box
            sx={{
              width: 80,
              height: 80,
              mb: 3,
              mx: 'auto',
              borderRadius: 2,
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 32,
              fontWeight: 700,
              color: 'white',
            }}
          >
            NAS
          </Box>

          <Button
            variant="contained"
            size="large"
            startIcon={<LoginIcon />}
            onClick={login}
            sx={{
              px: 5,
              py: 1.5,
              fontSize: '1.1rem',
              borderRadius: 2,
            }}
          >
            使用群晖账号登录
          </Button>

          <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 3 }}>
            仅限管理员访问 · 使用群晖 DSM 账号授权登录
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
